import { FC, PropsWithChildren, ReactNode } from 'react'
import { useTrackVisibility } from 'react-intersection-observer-hook'

type Props = {
  /**
   * root margin as per IntersectionObserver API:
   * https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API#how_intersection_is_calculated
   */
  rootMargin: string
  placeholder: ReactNode
}

const RenderOnlyWhenVisible: FC<PropsWithChildren<Props>> = ({
  children,
  rootMargin,
  placeholder,
}) => {
  const [ref, { isVisible, wasEverVisible }] = useTrackVisibility({
    rootMargin,
  })

  const renderPlaceholder = isVisible !== true && wasEverVisible === true

  return (
    <div ref={ref}>
      {renderPlaceholder ? <>{placeholder}</> : <>{children}</>}
    </div>
  )
}

export default RenderOnlyWhenVisible
